export const commercialYearlyHistory = {
  C001: {
    years: ["2022", "2023", "2024", "2025"],
    monthlyData: {
      "2022": [980, 860, 780, 720, 680, 640, 620, 650, 740, 860, 1020, 1120],
      "2023": [1120, 980, 880, 820, 760, 720, 700, 730, 840, 980, 1160, 1280],
      "2024": [1280, 1120, 1000, 920, 860, 810, 780, 820, 940, 1080, 1280, 1420],
      "2025": [1580, 1320, 1180, 1050, 980, 920, 880, 910, 1020, 1180, 1380, 1520],
    },
    yearlyTotal: { "2022": 9670, "2023": 10990, "2024": 12270, "2025": 13920 },
    yearlyGrowth: { "2022": null, "2023": 13.7, "2024": 11.6, "2025": 13.4 },
  },
  C002: {
    years: ["2022", "2023", "2024", "2025"],
    monthlyData: {
      "2022": [7200, 6800, 6200, 5800, 5400, 5100, 4900, 5100, 5800, 6500, 7200, 7800],
      "2023": [8200, 7600, 7000, 6500, 6100, 5800, 5600, 5800, 6600, 7400, 8200, 8900],
      "2024": [9200, 8600, 7800, 7200, 6800, 6400, 6200, 6500, 7400, 8300, 9100, 9800],
      "2025": [10256, 9856, 8562, 7856, 7256, 6856, 6562, 6856, 7856, 8856, 9562, 10256],
    },
    yearlyTotal: { "2022": 73800, "2023": 83700, "2024": 93300, "2025": 100392 },
    yearlyGrowth: { "2022": null, "2023": 13.4, "2024": 11.5, "2025": 7.6 },
  },
  C003: {
    years: ["2022", "2023", "2024", "2025"],
    monthlyData: {
      "2022": [22000, 19500, 17500, 15500, 14000, 13000, 12200, 12800, 15600, 18500, 21000, 23000],
      "2023": [25000, 22000, 19800, 17500, 15800, 14600, 13800, 14500, 17600, 21000, 23800, 26000],
      "2024": [28500, 25000, 22500, 19800, 17800, 16500, 15600, 16400, 20000, 23800, 27000, 29500],
      "2025": [32560, 28560, 25680, 22560, 20256, 18856, 17562, 18256, 22856, 26856, 30562, 33256],
    },
    yearlyTotal: { "2022": 184600, "2023": 211400, "2024": 242400, "2025": 297820 },
    yearlyGrowth: { "2022": null, "2023": 14.5, "2024": 14.7, "2025": 22.9 },
  },
};

export const flowmeterRealtimeData = {
  C001: {
    deviceId: "IOT-C001-FM",
    model: "LWQ-50涡轮流量计",
    currentFlow: 42.6,
    dailyTotal: 856.3,
    monthlyTotal: 12568.5,
    pressure: 0.12,
    temperature: 20.3,
    signalStrength: 95,
    batteryLevel: 88,
    lastUpdate: "2026-04-10 14:28:35",
    status: "正常",
    alarmStatus: "无告警",
    hourlyFlow: [28, 32, 38, 45, 52, 48, 42, 38, 35, 30, 28, 25, 22, 20, 18, 22, 35, 48, 56, 62, 58, 52, 45, 38],
    pressureHistory: [0.11, 0.12, 0.12, 0.13, 0.12, 0.11, 0.12, 0.12, 0.13, 0.12, 0.11, 0.12],
    temperatureHistory: [19.8, 20.1, 20.3, 20.5, 20.4, 20.2, 20.3, 20.1, 19.9, 20.0, 20.2, 20.3],
  },
  C002: {
    deviceId: "IOT-C002-FM",
    model: "LWQ-200涡轮流量计",
    currentFlow: 285.6,
    dailyTotal: 5862.3,
    monthlyTotal: 85623.5,
    pressure: 0.38,
    temperature: 18.2,
    signalStrength: 98,
    batteryLevel: 92,
    lastUpdate: "2026-04-10 14:28:42",
    status: "正常",
    alarmStatus: "无告警",
    hourlyFlow: [180, 210, 250, 290, 320, 310, 285, 260, 240, 220, 200, 185, 170, 165, 160, 180, 240, 310, 360, 380, 360, 330, 300, 270],
    pressureHistory: [0.37, 0.38, 0.38, 0.39, 0.38, 0.37, 0.38, 0.38, 0.39, 0.38, 0.37, 0.38],
    temperatureHistory: [18.0, 18.1, 18.2, 18.4, 18.3, 18.1, 18.2, 18.0, 17.9, 18.0, 18.1, 18.2],
  },
  C003: {
    deviceId: "IOT-C003-FM",
    model: "LWQ-500超声波流量计",
    currentFlow: 856.2,
    dailyTotal: 18562.8,
    monthlyTotal: 256823.6,
    pressure: 0.82,
    temperature: 22.1,
    signalStrength: 99,
    batteryLevel: 95,
    lastUpdate: "2026-04-10 14:28:50",
    status: "正常",
    alarmStatus: "无告警",
    hourlyFlow: [520, 580, 650, 720, 800, 860, 856, 820, 780, 740, 700, 660, 620, 600, 580, 620, 720, 820, 900, 950, 920, 880, 840, 800],
    pressureHistory: [0.80, 0.81, 0.82, 0.83, 0.82, 0.81, 0.82, 0.82, 0.83, 0.82, 0.81, 0.82],
    temperatureHistory: [21.8, 22.0, 22.1, 22.3, 22.2, 22.0, 22.1, 21.9, 21.8, 22.0, 22.1, 22.1],
  },
};

export const safetyInspectionHistory = [
  { date: "2026-02-01", result: "合格", score: 96, inspector: "李工", issues: "无", nextDate: "2026-08-01" },
  { date: "2025-08-01", result: "合格", score: 94, inspector: "王工", issues: "流量计接头轻微渗漏，已处理", nextDate: "2026-02-01" },
  { date: "2025-02-01", result: "合格", score: 92, inspector: "张工", issues: "无", nextDate: "2025-08-01" },
  { date: "2024-08-01", result: "合格", score: 90, inspector: "李工", issues: "报警器电池电量低，已更换", nextDate: "2025-02-01" },
  { date: "2024-02-01", result: "合格", score: 91, inspector: "王工", issues: "无", nextDate: "2024-08-01" },
];
